import {
    FETCHED_DESTINATIONS,
    FETCHED_TRIP_FORMATS,
    FETCHED_TYPES_OF_WORK,
    FETCHED_PAGES_TAGS,
} from './types';

export function fetchedDestinations(destinations) {
    return {
        type: FETCHED_DESTINATIONS,
        destinations
    }
}

export function fetchedTripFormats(tripFormats) {
    return {
        type: FETCHED_TRIP_FORMATS,
        tripFormats
    }
}

export function fetchedTypesOfWork(typesOfWork) {
    return {
        type: FETCHED_TYPES_OF_WORK,
        typesOfWork
    }
}

export function fetchedPageTags(tags) {
    return {
        type: FETCHED_PAGES_TAGS,
        tags
    }
}


// WEBPACK FOOTER //
// ./src/containers/taxonomy/actions.js